var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseIcon1 = function SvgPauseIcon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.575.387c.74.273 1.232.979 1.232 1.768v18.69c0 .79-.492 1.495-1.232 1.768a6.28 6.28 0 0 1-4.342 0A1.88 1.88 0 0 1 0 20.845V2.155C0 1.365.492.66 1.233.387a6.28 6.28 0 0 1 4.342 0"
  })));
};
export default SvgPauseIcon1;